import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox } from "vue";
const _hoisted_1 = { class: "customersTrelloFiltersContainer" };
const _hoisted_2 = { class: "filterContainer" };
const _hoisted_3 = { class: "filterContainer" };
const _hoisted_4 = { class: "filterBody" };
const _hoisted_5 = ["value"];
const _hoisted_6 = { class: "form-group ml-2" };
const _hoisted_7 = { class: "filterContainer" };
const _hoisted_8 = { class: "filterBody" };
const _hoisted_9 = { class: "filterContainer" };
const _hoisted_10 = { class: "filterBody" };
const _hoisted_11 = ["value"];
const _hoisted_12 = { class: "filterContainer" };
const _hoisted_13 = { class: "filterBody" };
const _hoisted_14 = ["value"];
const _hoisted_15 = { class: "filterContainer" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_toggler = _resolveComponent("toggler");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                placeholder: "Cliente/Agenzia",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.vm.name) = $event))
            }, null, 512), [
                [_vModelText, _ctx.vm.name]
            ])
        ]),
        _createElementVNode("div", _hoisted_3, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "filterTitle" }, " Gestito da ", -1)),
            _createElementVNode("div", _hoisted_4, [
                _withDirectives(_createElementVNode("select", {
                    class: "form-control",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.vm.officeIdentifier) = $event))
                }, [
                    _cache[8] || (_cache[8] = _createElementVNode("option", { value: "" }, "Mostra tutti", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offices, (item, i) => {
                        return (_openBlock(), _createElementBlock("option", {
                            value: item.identifier,
                            key: i
                        }, _toDisplayString(item.name), 9, _hoisted_5));
                    }), 128))
                ], 512), [
                    [_vModelSelect, _ctx.vm.officeIdentifier]
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_6, [
            _cache[10] || (_cache[10] = _createElementVNode("label", null, [
                _createTextVNode("Solo "),
                _createElementVNode("i", { class: "fas fa-snowflake text-info" })
            ], -1)),
            _createElementVNode("div", null, [
                _createVNode(_component_toggler, {
                    modelValue: _ctx.vm.onlyFreezed,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.vm.onlyFreezed) = $event))
                }, null, 8, ["modelValue"])
            ])
        ]),
        _createElementVNode("div", _hoisted_7, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "filterTitle" }, " Clienti/Non clienti ", -1)),
            _createElementVNode("div", _hoisted_8, [
                _cache[11] || (_cache[11] = _createElementVNode("label", null, "Mostra clienti", -1)),
                _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.vm.showClienti) = $event))
                    }, null, 512), [
                        [_vModelCheckbox, _ctx.vm.showClienti]
                    ])
                ]),
                _cache[12] || (_cache[12] = _createElementVNode("label", null, "Mostra non clienti", -1)),
                _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.vm.showNonClienti) = $event))
                    }, null, 512), [
                        [_vModelCheckbox, _ctx.vm.showNonClienti]
                    ])
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_9, [
            _cache[14] || (_cache[14] = _createElementVNode("div", { class: "filterTitle" }, " Cluster ", -1)),
            _createElementVNode("div", _hoisted_10, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.config.clusters, (cluster, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: "d-inline-block ml-2",
                        key: i
                    }, [
                        _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            class: "form-control",
                            value: cluster,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.vm.clusterFilter) = $event))
                        }, null, 8, _hoisted_11), [
                            [_vModelCheckbox, _ctx.vm.clusterFilter]
                        ]),
                        _createTextVNode(" " + _toDisplayString(cluster), 1)
                    ]));
                }), 128))
            ])
        ]),
        _createElementVNode("div", _hoisted_12, [
            _cache[15] || (_cache[15] = _createElementVNode("div", { class: "filterTitle" }, " Stelle ", -1)),
            _createElementVNode("div", _hoisted_13, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (item) => {
                    return _createElementVNode("div", {
                        class: "d-inline-block ml-2",
                        key: item
                    }, [
                        _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            class: "form-control",
                            value: item - 1,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.vm.stelleFilter) = $event))
                        }, null, 8, _hoisted_14), [
                            [_vModelCheckbox, _ctx.vm.stelleFilter]
                        ]),
                        _createTextVNode(" " + _toDisplayString(item - 1), 1)
                    ]);
                }), 64))
            ])
        ]),
        _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
                type: "button",
                class: "btn btn-green ml-2",
                onClick: _cache[7] || (_cache[7] = ($event) => (_ctx.$emit('apply', _ctx.vm)))
            }, "Applica")
        ])
    ]));
}
